<template>
  <div>
    <jd-title label="展示店铺"></jd-title>
    <el-form-item
      class="mt16"
      label="小程序店铺信息："
      required
      label-width="140px"
    >
      <el-radio-group v-model="customerPaperworkData.shopNameType">
        <el-radio :label="0">统一显示配置店铺</el-radio>
        <el-radio :label="2">不显示店铺信息</el-radio>
      </el-radio-group>
    </el-form-item>
    <jd-title label="更多活动配置"></jd-title>
    <el-form-item label="活动浮窗：" class="mt16">
      <el-radio-group
        v-model="customerPaperworkData.moreActSet.isShowFloatWindow"
        @change="changeShowFloatWindow"
      >
        <el-radio :label="0">不显示</el-radio>
        <el-radio :label="1">显示</el-radio>
      </el-radio-group>
      <div
        class="set-box"
        v-if="customerPaperworkData.moreActSet.isShowFloatWindow"
      >
        <el-form-item label="浮窗图：" label-width="auto">
          <div class="floatImg">
            <uploadCom
              :imgUrl.sync="customerPaperworkData.moreActSet.floatWindowImg"
            />
            <el-button
              type="text"
              style="width: auto"
              @click="customerPaperworkData.moreActSet.floatWindowImg = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/float-icon.png'"
              >重置</el-button
            >
            <span class="upload-tip">尺寸建议：100px*100px</span>
          </div>
        </el-form-item>
        <jumpLinkCom
          v-model="customerPaperworkData.moreActSet"
          :isRequired="false"
          jumpLabel="跳转链接:"
        />
      </div>
    </el-form-item>
    <el-form-item label="活动banner：">
      <el-radio-group
        v-model="customerPaperworkData.moreActSet.isShowBanner"
        @change="changeShowBanner"
      >
        <el-radio :label="0">不显示</el-radio>
        <el-radio :label="1">显示</el-radio>
      </el-radio-group>
      <actBannerCom
        class="mt12"
        v-if="customerPaperworkData.moreActSet.isShowBanner"
        :list.sync="customerPaperworkData.moreActSet.bannerList"
        :tableInfo="tableInfo"
      />
    </el-form-item>
  </div>
</template>
<script>
import uploadCom from "./commCustomizationSet/uploadCom.vue";
import jumpLinkCom from "./jumpLinkCom.vue";
import actBannerCom from "./actBannerCom.vue";
export default {
  components: {
    uploadCom,
    jumpLinkCom,
    actBannerCom,
  },
  model: {
    prop: "customerPaperwork",
    event: "customerPaperworkUpdate",
  },
  props: {
    customerPaperwork: {
      type: Object,
      default: () => ({
        shopNameType: 0,
      }),
    },
    isShowShopName: {
      type: Boolean,
      default: true,
    },
    isShowMoreSet: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableInfo: [
        {
          label: "banner图",
          prop: "bannerUrl",
          slot: "bannerUrlSlot",
        },
        {
          label: "跳转链接",
          prop: "goShopUrl",
          slot: "goShopUrlSlot",
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
        },
      ],
    };
  },
  computed: {
    customerPaperworkData: {
      get: function () {
        return this.customerPaperwork;
      },
      set: function (val) {
        this.$emit("customerPaperworkUpdate", val);
      },
    },
  },
  watch: {
    customerPaperwork: {
      handler: function (v) {
        if (this.isShowShopName) {
          if (v.shopNameType) {
            this.$set(this.customerPaperwork, "shopNameType", v.shopNameType);
          } else {
            this.$set(this.customerPaperwork, "shopNameType", 0);
          }
        }
        // 新增活动浮窗配置
        if (this.isShowMoreSet) {
          if (v.moreActSet) {
            this.$set(this.customerPaperwork, "moreActSet", v.moreActSet);
          } else {
            this.$set(this.customerPaperwork, "moreActSet", {
              isShowFloatWindow: 0, //是否显示活动浮窗：0-不显示，1-显示
              floatWindowImg: "", //活动浮窗图
              goShopSetting: 0, //活动浮窗跳转设置：0-不跳转，1-跳转
              goShopAppId: "", //活动浮窗跳转小程序ID
              goShopUrl: "",
              isShowBanner: 0, //是否显示活动banner：0-不显示，1-显示
              bannerList: [],
            });
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    changeShowBanner() {
      this.customerPaperworkData.moreActSet.bannerList = [];
    },
    changeShowFloatWindow(val) {
      if(val==1) {
        this.customerPaperworkData.moreActSet.floatWindowImg = "https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/float-icon.png";
      } else {
        this.customerPaperworkData.moreActSet.floatWindowImg = "";
      }
     
      this.customerPaperworkData.moreActSet.goShopSetting = 0;
      this.customerPaperworkData.moreActSet.goShopAppId = "";
      this.customerPaperworkData.moreActSet.goShopUrl = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.mt16 {
  margin-top: 16px;
}
.set-box {
  width: 700px;
  padding: 20px;
  background: #f4f6fa;
  border-radius: 4px 4px 4px 4px;
  .floatImg {
    display: flex;
    align-items: flex-end;
    .upload-tip {
      font-size: 14px;
      color: #999999;
    }
  }
}
.ml8 {
  margin-left: 8px;
}
.mt12 {
  margin-top: 12px;
}
</style>
